import type { Arrival } from '@efdigital/ll-addon-data';
import { DataTypeXceed } from '@efdigital/ll-addon-data/data-types';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';
import { query } from '@warp-drive/utilities/json-api';

import type { ProgramsProgramCohortModel } from '../cohort.ts';
import { createDefaultArrival } from './arrivals-defaults.ts';

export type ProgramsProgramCohortArrivalsModel = ProgramsProgramCohortModel & {
  arrival: Arrival;
};

export default class ProgramsProgramCohortArrivalsRoute extends Route<ProgramsProgramCohortArrivalsModel> {
  @service declare store: Store;

  async model() {
    const { cohort } = this.modelFor(
      'programs.program.cohort'
    ) as ProgramsProgramCohortModel;

    const result = await this.store.request(
      query<Arrival>(
        DataTypeXceed.Arrival,
        {
          'filter[cohort.id]': cohort.id,
          include: ['calendarItems', 'contacts', 'files'],
        },
        jsonApiOptions
      )
    );

    const arrival =
      result.content.data[0] ?? createDefaultArrival(this.store, cohort);

    return {
      ...(this.modelFor(
        'programs.program.cohort'
      ) as ProgramsProgramCohortModel),
      arrival,
    };
  }
}
